/* global axios */
import ApiClient from './ApiClient';

class HotelBookingsAPI extends ApiClient {
  constructor() {
    super('hotel_bookings', { accountScoped: true });
  }

  getRooms() {
    return axios.get(`${this.url}/rooms`);
  }

  getMotorReservaQuoteData() {
    return axios.get(`${this.url}/motor_reserva_quote_data`);
  }

  getAvailableRooms(checkIn, checkOut) {
    return axios.get(`${this.url}/available_rooms`, {
      params: { check_in: checkIn, check_out: checkOut },
    });
  }

  getByContact(contactId) {
    return axios.get(this.url, { params: { contact_id: contactId } });
  }

  getByConversation(conversationId) {
    return axios.get(this.url, { params: { conversation_id: conversationId } });
  }

  checkAsaasPayment(bookingId) {
    return axios.post(`${this.url}/${bookingId}/check_asaas_payment`);
  }

  generatePayment(bookingId, data) {
    return axios.post(`${this.url}/${bookingId}/generate_payment`, data);
  }

  confirmPaymentManual(bookingId) {
    return axios.post(`${this.url}/${bookingId}/confirm_payment_manual`);
  }
}

export default new HotelBookingsAPI();
